import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/brand/StoryView.vue"),
  },
  {
    path: "/designer-story",
    name: "designer-story",
    component: () => import("../views/brand/DesignerStory.vue"),
  },
  {
    path: "/brand-craftsmanship",
    name: "brand-craftsmanship",
    component: () => import("../views/brand/BrandCraftsmanship.vue"),
  },
  {
    path: "/brand-blockbuster",
    name: "brand-blockbuster",
    component: () => import("../views/brand/BrandBlockbuster.vue"),
  },
  {
    path: "/brand-blockbuster-detail/:id",
    name: "brand-blockbuster-detail",
    component: () => import("../views/brand/BlockBusterDetail.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/IndexView.vue"),
    children: [
      {
        path: "latest",
        name: "latest",
        component: () => import("../views/news/LatestView.vue"),
      },
      {
        path: "media",
        name: "media",
        component: () => import("../views/news/MediaView.vue"),
      },
      {
        path: "activity",
        name: "activity",
        component: () => import("../views/news/ActivityView.vue"),
      },
      {
        path: "trend",
        name: "trend",
        component: () => import("../views/news/TrendView.vue"),
      },
      {
        path: "detail/:id",
        name: "news-detail",
        component: () => import("../views/news/DetailView.vue"),
      },
    ],
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactUs.vue"),
  },
  {
    path: "/map",
    name: "map",
    component: () => import("../views/MapView.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  // 跳转页面滚动条重置为顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则滚动到顶部
    // 由于 #app 是滚动容器，需要等待 DOM 更新后滚动
    return new Promise((resolve) => {
      // 使用 nextTick 确保 DOM 更新完成
      Vue.nextTick(() => {
        const appElement = document.getElementById("app");
        if (appElement) {
          appElement.scrollTop = 0;
          appElement.scrollLeft = 0;
        }
        resolve({ x: 0, y: 0 });
      });
    });
  },
});

export default router;
